import { MinTableKey } from "./table";

export const CONTEXTS = {
  WORK: "work",
  HOME: "home",
} as const;
export type Context = (typeof CONTEXTS)[keyof typeof CONTEXTS];

export type TodoData = {
  type: "todo";
  id: string;
  userId: string;
  title: string;
  notes?: string;
  context: Context;
  categoryId?: string;
  priority?: number;
  complexity?: number;
  done: boolean;
  doneAt?: string;
  scheduledDate?: string; // YYYY-MM-DD, always client-local — never computed server-side
  order: number;
  timesScheduled: number;
  createdAt: string; // ISO, server-set
  updatedAt: string; // ISO, server-set
};

export type TodoDBData = MinTableKey & TodoData;
